export const USER_SETTINGS_GET_USER_SETTINGS =
  'USER_SETTINGS_GET_USER_SETTINGS';
export const USER_SETTINGS_SET_USER_SETTINGS =
  'USER_SETTINGS_SET_USER_SETTINGS';



// WEBPACK FOOTER //
// ./src/common/UserSettings/state/types.js